export default __webpack_public_path__ + "static/media/placeholder.d447a8bd.png";